import React from 'react';
import { Card, Button, Container, Row, Col, Accordion, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
// import { TypeAnimation } from "react-type-animation";
import { Carousel } from 'react-bootstrap';
import './BackgroundCarousel.css';
import './Home.css';
import './Typed.css';
import TextType from './TextType';

// Images
import Card1img1 from '../img/Home/Card 1/LO.jpg';
import Card1img2 from '../img/Home/Card 1/FA.jpg';
import Card1img3 from '../img/Home/Card 1/CRM.jpg';
import Card2img1 from '../img/Home/Card 2/AELS.jpg';
import Card2img2 from '../img/Home/Card 2/SELS.jpg';
import Card2img3 from '../img/Home/Card 2/AILS.jpg';
import Card2img4 from '../img/Home/Card 2/SILS.jpg';
import Card2img5 from '../img/Home/Card 2/FAS.jpg';
import Card2img6 from '../img/Home/Card 2/CRM.jpg';
// import Accordian from '../img/Accordian Side.jpg'
import Accordian from '../img/New Pics/logistics-cargo-service-freight-forwarding-agency-transport.png'

//Banner
import Banner1 from "../img/Home/Banner/Banner1.png"
import Banner2 from "../img/Home/Banner/Banner2.jpg"
import Banner3 from "../img/Home/Banner/Banner3.jpg"
import Banner4 from "../img/Home/Banner/Banner4.jpg"
import Banner5 from "../img/Home/Banner/Banner5.jpg"
import Banner6 from "../img/Home/Banner/Banner6.jpg"


function Home() {

  // Shared Card rendering function
  const renderCard = (img, title, text, link) => (
    <Col xs={12} sm={6} md={4} className="d-flex">
      <Card
        as={Link} // Makes the whole card clickable
        to={link}
        className="m-2 p-3 flex-fill card-hover-effect border-primary" style={{ border: '3px solid #0d6efd', textDecoration: 'none' }}>
        <Card.Img variant="top" height={250} src={img} />
        <Card.Body>
          <Card.Title>{title}</Card.Title>
          <Card.Text>{text}</Card.Text>
        </Card.Body>
      </Card>
    </Col>
  );

  const images = [
    Banner1,
    Banner2,
    Banner3,
    Banner4,
    Banner5,
    Banner6,
  ];

  return (
    <div>
      {/* === Hero Section === */}
      <div>
        <Carousel indicators={false} fade interval={5000} className="bg-carousel">
          {images.map((src, index) => (
            <Carousel.Item key={index}>
              <div
                className="carousel-background"
                style={{ backgroundImage: `url(${src})` }}
              ></div>

              <Carousel.Caption className="d-flex justify-content-center align-items-center text-center caption-full">
                <Container>
                  <Row className="justify-content-center">
                    <Col md={8}>
                      <motion.div
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1, delay: 0.5 }}
                        className="mt-3 fs-5"
                      >
                        <div className='typed-text1'>
                          <TextType
                          text={["Digitalizing", "Versitile", "Flexiblity"]}
                          typingSpeed={75}
                          pauseDuration={1500}
                          showCursor={true}
                          cursorCharacter="|"
                        />
                        </div>
                        
                        {/* <div className='typed-text1'>
                          <TypeAnimation
                            sequence={[
                              "Digitalizing",
                              "Versitile",
                              "Flexiblity",
                            ]}
                            speed={600}
                            repeat={Infinity}
                          />
                        </div> */}
                        {/* <motion.h1>Digitalizing</motion.h1>
                        <motion.h1>Versitile</motion.h1>
                        <motion.h1>Flexiblity</motion.h1> */}
                        <div className="typed-text">
                          <TextType
                          text={["Logistics",
                                "Supply Chain Industries",
                                "Freight Forwarding",
                                "Transport",
                                "Warehouse",
                                "Business Email",
                                "Web Development",]}
                          typingSpeed={75}
                          pauseDuration={1500}
                          showCursor={true}
                          cursorCharacter="|"
                        />
                            {/* <TypeAnimation
                              sequence={[
                                "Logistics",
                                "Supply Chain Industries",
                                "Freight Forwarding",
                                "Transport",
                                "Warehouse",
                                "Business Email",
                                "Web Development",
                              ]}
                              speed={400}
                              repeat={Infinity}
                            /> */}
                        </div>
                        <motion.p style={{ fontSize: "clamp(0.9rem, 3vw, 2.8rem)" }}>
                          Integrate, Control And Empower Your Logistics And Freight
                          Forwarding Operations With Our Latest Technologies
                        </motion.p>
                      </motion.div>
                    </Col>
                  </Row>
                </Container>
              </Carousel.Caption>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      {/* === Integrated Solution Section === */}
      <motion.div className='py-4' initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.5 }}>
        <Container className=" my-5">
          <motion.h1 className='py-4 text-center'>Integrated Solution for Logistics And Freight Forwarding Industries</motion.h1>
          {/* <motion.p className='fs-6 text-center'>
            CATUS is integrated software solution to manage all business activities that associated with
            Operational and Financial. We, Catus Technologies is …
          </motion.p> */}
          <motion.p className='fs-6 text-justify'>Catus Technologies transcends traditional logistics management by helping you envision and implement a successful business model that drives sustainable growth. The software elevates your business to new heights of integration by connecting various operational facets—such as inventory, transportation, and financials—into a unified system. This holistic approach fosters collaboration across departments and enhances overall efficiency. Additionally, Catus offers the flexibility to access your business from almost anywhere via computer, enabling remote management, real-time oversight, and decision-making from any location with an internet connection. This accessibility is particularly valuable in today’s globalized and fast-paced market, where flexibility and responsiveness are key to success.</motion.p>
          <Row>
          </Row>
          <Row className="py-4 align-items-center">
            {/* Image Column */}
            <Col xs={12} md={6} className="mb-4 mb-md-0">
              <Image
                className="acordn-hover-effect img-fluid rounded"
                src={Accordian}
                alt="Accordion Example"
                fluid // Bootstrap's responsive image handling
              />
            </Col>

            {/* Accordion Column */}
            <Col xs={12} md={6}>
              <Accordion className="m-2" defaultActiveKey="0">
                {/* Logistics Operations */}
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Logistics Operations</Accordion.Header>
                  <Accordion.Body>
                    <Link
                      to="/LogisticsOperations"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      className="d-flex flex-wrap align-items-start gap-3"
                    >
                      <div className="d-flex flex-wrap align-items-start gap-3">
                        <Image
                          src={Card1img1}
                          alt="Logistics Operations"
                          className="rounded"
                          style={{ maxWidth: "150px", height: "auto" }}
                          fluid
                        />
                        <p className="mb-0">
                          CATUS is integrated software solution to manage all business activities that are associated with
                          Operational and Financial. Logistics operations software it …
                        </p>
                      </div>
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>

                {/* Financial Accounting */}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Financial Accounting</Accordion.Header>
                  <Accordion.Body>
                    <Link
                      to="/FinancialAccountingSoftware"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      className="d-flex flex-wrap align-items-start gap-3"
                    >
                      <div className="d-flex flex-wrap align-items-start gap-3">
                        <Image
                          src={Card1img2}
                          alt="Financial Accounting"
                          className="rounded"
                          style={{ maxWidth: "150px", height: "auto" }}
                          fluid
                        />
                        <p className="mb-0">
                          CATUS is designed based on international accounting principles.
                          Logistics software with financial accounting provides the facility of multiple currency transactions, …
                        </p>
                      </div>
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>

                {/* CRM */}
                <Accordion.Item eventKey="3">
                  <Accordion.Header>CRM</Accordion.Header>
                  <Accordion.Body>
                    <Link
                      to="/CRM"
                      style={{ textDecoration: 'none', color: 'inherit' }}
                      className="d-flex flex-wrap align-items-start gap-3"
                    >
                      <div className="d-flex flex-wrap align-items-start gap-3">
                        <Image
                          src={Card1img3}
                          alt="CRM Software"
                          className="rounded"
                          style={{ maxWidth: "150px", height: "auto" }}
                          fluid
                        />
                        <p className="mb-0">
                          Catus Software is a user-friendly application which gives a helping hand to your organisation to manage
                          data, resources, performance, and …
                        </p>
                      </div>
                    </Link>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>

          {/* <h4 className='text-danger my-4'><strong>CATUS LMS Modules</strong></h4>
          <ul>
            <li className='fs-6'><strong>Air Export Logistics Software</strong>: Manages the export of goods via air with comprehensive tracking and documentation.</li>
            <li className='fs-6'><strong>Sea Export Logistics Software</strong>: Oversees sea-based exports with end-to-end process management.</li>
            <li className='fs-6'><strong>Air Import Logistics Software</strong>: Handles air import operations with automated output generation.</li>
            <li className='fs-6'><strong>Sea Import Logistics Software</strong>: Manages sea import logistics with multi-modal support.</li>
            <li className='fs-6'><strong>Financial Accounting</strong>: Integrates financial tracking and reporting for logistics operations.</li>
            <li className='fs-6'><strong>Customized Business Email Services</strong>: Provides tailored communication tools for business needs.</li>
            <li className='fs-6'><strong>Website Development</strong>: Offers professional website creation to enhance online presence.</li>
          </ul> */}

          <div className="d-flex justify-content-center">
            <Button
              as={Link}
              to="IntegratedSolutionForAllDepartments"
              className="mt-2 btn-lg"
              variant="primary"
            >
              More About Us
            </Button>
          </div>
        </Container>
      </motion.div>
      <Container>
        <hr />
      </Container>
      {/* === What We Do Section === */}
      <Container className="text-center my-5 ">
        <h1>What We Do?</h1>
        <p className='fs-6'>
          CATUS provides an extremely unmatched software solution to Logistics and Freight forwarding service provider industries,
          It includes complete operational and …
        </p>
        <Row>
          {renderCard(Card2img1, 'Air Export Logistics Software', 'CATUS Air Export Logistics Software in New Delhi provides services to streamline your business, increase your productivity and generate bigger …', '/AirExportLogisticsSoftware')}
          {renderCard(Card2img2, 'Sea Export Logistics Software', 'Catus Ocean/Sea Export Logistics Software Module efficiently manages container shipments throughout the complete life-cycle. Under the Sea Export Logistics Software …', '/SeaExportLogisticsSoftware')}
          {renderCard(Card2img3, 'Air Import Logistics Software', 'Catus Technologies: Logistics Solution Software  provides complete air, ocean and road, import, export, domestic and trans-border, single shipment, consolidation and …', '/AirImportLogisticsSoftware')}
          {renderCard(Card2img4, 'Sea Import Logistics Software', 'Sea Import Logistics Software provides complete air, ocean and road, import, export, domestic and trans-border, single shipment, consolidation and de-consolidation …', '/SeaImportLogisticsSoftware')}
          {renderCard(Card2img5, 'Financial Accounting Software', 'CATUS LMS is designed based on international accounting principles. Freight & Logistics financial accounting software it facilitates multiple currency transactions, …', '/FinancialAccountingSoftware')}
          {renderCard(Card2img6, 'CRM', 'Catus Software is a user-friendly application which gives a helping hand to your organisation to manage data, resources, performance, and …', '/CRM')}
        </Row>
        <Button as={Link} to="WhatWeDo" className="my-3 btn-lg" variant="primary">
          View More
        </Button>
      </Container>
    </div>
  );
}
export default Home;